<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('scope.text_283')"
    icon="menu-tenant"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions
        :options="singleActions"
        :row="detailData"
        button-type="link"
        button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :serverColumns="columns"
      :res-id="data.id"
      :bill-id="detailData.billing_account_id"
      :getParams="getParams"
      :on-manager="onManager"
      @refresh="refresh"
      @single-refresh="singleRefresh"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'
import AccountDetail from '../../bill-overview/components'
import InvoiceAddressList from '../../invoice-address-manager/components/List'
import InvoiceInfoList from '../../invoice-info-manager/components/List'
import LicenseList from '../../license/components/List'
import DownloadList from '../../download-history/components/List'
import TenantDetail from './Detail'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import CloudaccountList from '@Cloudenv/views/cloudaccount/components/List'
import VoucherList from '../../voucher-manager/components/List'

export default {
  name: 'TenantManagerSidePage',
  components: {
    Actions,
    TenantDetail,
    CloudaccountList,
    LicenseList,
    DownloadList,
    AccountDetail,
    InvoiceAddressList,
    InvoiceInfoList,
    VoucherList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('scope.text_433'), key: 'tenant-detail' },
        { label: this.$t('cloudenv.text_12'), key: 'cloudaccount-list' },
        { label: this.$t('scope.text_288'), key: 'license-list' },
        { label: this.$t('scope.text_655'), key: 'download-list' },
        { label: this.$t('scope.text_932'), key: 'account-detail' },
        { label: '代金券', key: 'voucher-list' },
        { label: this.$t('scope.text_281'), key: 'invoice-address-list' },
        { label: this.$t('scope.text_282'), key: 'invoice-info-list' },
        { label: this.$t('scope.text_435'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'cloudaccount-list') {
        return {
          customer_id: this.data.id,
          domain_id: this.data.data.domain_id,
        }
      }
      if (this.params.windowData.currentTab === 'consumer-info') {
        return {
          entry: 'tenant-manager',
        }
      }
      if (this.params.windowData.currentTab === 'license-list' || this.params.windowData.currentTab === 'download-list') {
        return {
          customer_id: this.data.id,
        }
      }
      if (this.params.windowData.currentTab === 'invoice-address-list' || this.params.windowData.currentTab === 'invoice-info-list' || this.params.windowData.currentTab === 'voucher-list') {
        return {
          billing_account_id: this.detailData.billing_account_id,
        }
      }
      return null
    },
  },
}
</script>
